module.exports = __webpack_public_path__ + "static/media/menuHamberger.1d7c044c.svg";